import FormSubmissionState from '@/enums/FormSubmissionState';
import OptInData from '@/models/OptInData';
import IEnquiry from '@/models/interfaces/IEnquiry';
import Enquiry from '@/models/enquiry/Enquiry';
import Range from '@/models/vehicle/range';
import Accordion from '@/viewmodels/Accordion';
import KeyValue from '@/models/KeyValue';
import IEnquiryState from './interfaces/enquiry-state.d';

export default class EnquiryState implements IEnquiryState {
  public enquiry: IEnquiry = new Enquiry();

  public enquirySubmissionState: FormSubmissionState = FormSubmissionState.NotSubmitted;

  public showEnterPostcodeManually: boolean = false;

  public optInData: OptInData[] = [];

  public similarCarInterest: string = '';

  public currentStep: number = 1;

  public interactedSteps: number = 1;

  public overlayStep: number = 1;

  public nextButtonsClicked: string[] = [];

  public skippedStepIds: number[] = [];

  public notes: KeyValue[] = [];
}
